export default __webpack_public_path__ + "static/media/maure_de_bretagne9.40b3da81.jpg";